import Http from './http'
import { buildFilterUrl } from '../util/url-util'

class ObraService {
  constructor () {
    this.obrasUrl = 'obras'
  }

  list () {
    return Http.get(`${this.obrasUrl}/list`)
  }

  findOneById (id) {
    return Http.get(`${this.obrasUrl}/${id}`)
  }

  recomendar (id, value) {
    const recomendar = {
      recomendado: value
    }
    return Http.put(`${this.obrasUrl}/${id}/recomendado`, recomendar)
  }

  save (obra, id) {
    return Http.put(`${this.obrasUrl}/${id}`, obra)
  }

  create (obra) {
    return Http.post(`${this.obrasUrl}`, obra)
  }

  findAll (limit = 2000) {
    return Http.get(`${this.obrasUrl}?limit=${limit}&mostrarOcultos=0`)
  }

  getObrasPorMes () {
    return Http.get(`${this.obrasUrl}/added/month/year`)
  }

  getObrasPorEditora (quantidade) {
    return Http.get(`${this.obrasUrl}/editora/${quantidade}`)
  }

  getByTitle (filter) {
    let url = `${this.obrasUrl}`

    if (filter) {
      url += `?${this.buildFilterUrl(filter)}`
    }
    return Http.get(url)
  }

  getCsv () {
    return Http.get(`${this.obrasUrl}/csv`, { responseType: 'blob' })
  }
}

Object.assign(ObraService.prototype, { buildFilterUrl })

export default new ObraService()
